import axios from 'axios';
import storage from 'store';
import { Message } from 'element-ui';
import store from '../store/index';
import router from '../route/router';
import {
  VUE_APP_API_BASE_URL, APP_API_BASE_URL, ACCESS_TOKEN, USER_INFO,
} from './env';
// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: VUE_APP_API_BASE_URL,
  timeout: 60000, // 请求超时时间
});

let isRefreshing = false;
let requests = [];
// 异常拦截处理器
const errorHandler = (error) => Promise.reject(error);
const refreshTokenApi = () => request({
  url: '/session',
  method: 'put',
  params: {
    refresh_token: store.state.user.refresh_token,
  },
  baseURL: APP_API_BASE_URL,
});
// request interceptor
request.interceptors.request.use((config) => {
  const token = store.state.user.access_token || storage.get(ACCESS_TOKEN);
  if (!config.withoutToken) {
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      config.headers.Authorization = 'Basic b25saW5lLW51cnNlOm9ubGluZS1udXJzZQ==';
    }
  }
  if (!config.withoutHeaders) {
    config.headers.institution_id = store.state.shift.institution_id || '';
    config.headers.dept_id = store.state.shift.dept_id || '';
    config.headers.disease_id = store.state.shift.disease_id || '';
    config.headers.team_id = store.state.shift.team_id || '';
    config.headers.tenant = store.state.tenant.tenant || '';
  }
  return config;
}, errorHandler);

// response interceptor
request.interceptors.response.use((response) => {
  if (response.status !== 200 || response.data.code !== 0) {
    if (response.data.code === 30006) {
      Message.warning('登录状态过期，请重新登录');
      const route = router.currentRoute;
      store.dispatch('Logout').finally(() => {
        router.replace({
          path: '/user/login',
          query: { redirect: route.fullPath },
        });
      });
    } else if (response.data.code === 30007) {
      const { config } = response;
      if (!isRefreshing) {
        isRefreshing = true;
        return refreshTokenApi().then((res) => {
          if (res.code === 0) {
            const user = {
              ...store.state.user,
              access_token: res.data.access_token,
              refresh_token: res.data.refresh_token,
            };
            store.commit('setUser', user);
            store.commit('setAccessToken', res.data.access_token);
            storage.set(USER_INFO, user, 7 * 24 * 60 * 60 * 1000);
            storage.set(
              ACCESS_TOKEN,
              res.data.access_token,
              7 * 24 * 60 * 60 * 1000,
            );
            const token = store.state.user.access_token || storage.get(ACCESS_TOKEN);
            config.headers.Authorization = `Bearer ${token}`;
            requests.forEach((cb) => cb(token));
            requests = [];
            return request(config);
          }
          Message.warning('登录状态过期，请重新登录');
          const route = router.currentRoute;
          store.dispatch('Logout').finally(() => {
            router.replace({
              path: '/user/login',
              query: { redirect: route.fullPath },
            });
          });
        }).catch(() => {
          Message.warning('登录状态过期，请重新登录');
          const route = router.currentRoute;
          store.dispatch('Logout').finally(() => {
            router.replace({
              path: '/user/login',
              query: { redirect: route.fullPath },
            });
          });
        }).finally(() => {
          isRefreshing = false;
        });
      }
      return new Promise((resolve) => {
        Message.warning('登录状态过期，请重新登录');
        store.dispatch('Logout').finally(() => {
          router.replace({
            path: '/user/login',
          });
        });
        // requests.push(() => {
        //   config.headers.Authorization = `Bearer ${token}`;
        //   resolve(instance(config));
        // });
      });
    }
  }
  response.data['x-total-count'] = Number(
    response.headers['x-total-count'] || response.headers['X-TOTAL-COUNT'] || 0,
  );
  return response.data;
}, errorHandler);

export default request;
